import styled from 'styled-components'

import Image from 'shared/components/Image'
import { media } from 'shared/lib'
import { ArticleImageSet } from 'shared/types/ArticleImageSet'

export const ArticleFullImageSection = ({ section }: { section: ArticleImageSet }) => {
  const imageSize = section?.pictureSize

  return (
    <SectionContainer $addMargin={imageSize === 'small'}>
      <Image
        src={imageSize === 'large' ? section?.pictures?.[0]?.url : section?.pictures?.[0]?.smallUrl}
        alt=""
      />
    </SectionContainer>
  )
}

const SectionContainer = styled.div<{ $addMargin: boolean }>`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 120px 0;
  width: 100vw;
  height: auto;

  img {
    margin: auto;
    position: relative !important;
  }

  ${media.medium`
    margin: 240px 0px;

     img {
        max-width: 704px;
     }
  `}

  ${({ $addMargin }) =>
    $addMargin &&
    `
    padding: 0px;
    margin: 120px 0px;

    img {
       max-width: calc(100vw - 80px);
    }

    @media (min-width: ${768 / 16}em) {
      padding: 0px !important;
      margin: 240px 0px;

       img {
        max-width: 462px;
      }
    }
  `}
`
